module.exports = __webpack_public_path__ + "static/media/HEAD.2a6e73cf.png";